import {
  ROLES,
  type RoleStrategy,
  api,
  useMutation,
  useRoleConf,
  useToaster,
} from "@pharmupp/p3-front-commons"

export const usePublishAdminNewsPreview = (newsId: string) => {
  const toaster = useToaster()
  const roleEndpoint = useRoleConf(apiRoleConf(newsId))
  const { mutateAsync: publishNews } = useMutation({
    mutationFn: () =>
      api(roleEndpoint, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        mode: "cors",
      }),
    onError: () => {
      toaster.error("Une erreur est survenue")
    },
    onSuccess: () => {
      toaster.success("Actu publiée")
    },
  })

  return { publishNews }
}

const apiRoleConf = (id: string): RoleStrategy<string> => ({
  [ROLES.ADMIN]: `/api/news/post/${id}/publish`,
})
